/* eslint-disable react/no-multi-comp */

import React from 'react';
import { FormGroup, FormControl, ControlLabel } from 'rsuite';

//
// Form field standar
//
// eslint-disable-next-line react/display-name
export const TextField = React.forwardRef((props, ref) => {
    const { name, label, className, accepter, ...rest } = props;
    return (
        <div className={className || ''}>
            {/* <div className="col"> */}
            <FormGroup>
                <ControlLabel>{label}</ControlLabel>
                <FormControl name={name} accepter={accepter} {...rest}/>
            </FormGroup>
        </div>
    );
});

//
// Form field standar multifunction
//
// eslint-disable-next-line react/display-name
export const Field = React.forwardRef((props, ref) => {
    const { name, message, label, accepter, classNameGroup, classNameLabel, error, ...rest } = props;
    return (
        <FormGroup controlId={`${name}-10`} ref={ref} className={error ? 'has-error' : classNameGroup}>
            <ControlLabel className={classNameLabel}>{label} </ControlLabel>
            <FormControl name={name} accepter={accepter} errorMessage={error} {...rest} />
            {/* <HelpBlock>{message}</HelpBlock> */}
            {/* <Form.HelpText>{message}</Form.HelpText> */}
        </FormGroup>
    );
});
/*
1 - Example of input number
<Field name="number" label="Number" accepter={InputNumber} error={formError.number} />

2 - Example of checkbox
<Field
    name="skills"
    label="Skills"
    accepter={CheckboxGroup}
    error={formError.skills}
    inline
>
    <Checkbox value={'Node.js'}>Node.js</Checkbox>
    <Checkbox value={'CSS3'}>CSS3</Checkbox>
    <Checkbox value={'Javascript'}>Javascript</Checkbox>
    <Checkbox value={'HTML5'}>HTML5</Checkbox>
</Field>;

3 - Example of RadioGroup
< Field
    name = "browser"
    label = "Browser"
    accepter = { RadioGroup }
    error = { formError.browser }
    inline
>
    <Radio value={'Chrome'}>Chrome</Radio>
    <Radio value={'FireFox'}>FireFox</Radio>
    <Radio value={'IE'}>IE</Radio>
</Field >;

4 - Example of CheckPicker
<Field
    name="status"
    label="Status"
    accepter={CheckPicker}
    error={formError.status}
    style={{ display: 'inline-block', width: 200 }}
    data={[
        { label: 'Todo', value: 'todo' },
        { label: 'Open', value: 'open' },
        { label: 'Close', value: 'close' },
        { label: 'Error', value: 'error' },
        { label: 'Processing', value: 'processing' },
        { label: 'Done', value: 'done' }
    ]}
/>;

5 - Example of Slider
<Field
    accepter={Slider}
    min={0}
    max={20}
    name="level"
    label="Level"
    style={{ width: 200, margin: '10px 0' }}
    errorMessage={formError.level}
/>;

6 - Example of DatePicker
<Field
    accepter={DatePicker}
    name="createDate"
    label="Create Date"
    errorMessage={formError.createDate}
/>;
*/
